__turbopack_context__.v({
  "tableContainer": "IndicatorTable-module__zySx6q__tableContainer",
});
